import React, { useEffect, useState } from "react";
import { FILES_URL } from "../../utils/routes";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getFile } from "../../core/repo/fileRepo";
import Loader from "../../components/Loader";
import Page from "../../components/Page";
import { makeStyles } from "tss-react/mui";
import Content from "./Content";
import { useParams } from "react-router-dom";
import { deleteFile, updateFile } from "../../core/repo/fileRepo";
import {
  DELETE_FILE_SUCCESS,
  DELETE_FILE_FAILURE,
  EDIT_FILE_SUCCESS,
  EDIT_FILE_FAILURE,
} from "../../utils/posthogEvents";
import posthog from "posthog-js";
import { useSnackbar } from "notistack";
const useStyles = makeStyles()((theme) => ({
  root: {
    height: "100%",
  },
}));

function ViewFile() {
  const { enqueueSnackbar } = useSnackbar();
  const { classes } = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const { fileId } = useParams();
  const [file, setFile] = useState(null);
  console.log(file);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchFile();
  }, []);

  const fetchFile = async () => {
    try {
      const response = await dispatch(getFile(fileId));
      setFile(response);
    } catch (err) {
      console.log(err);
    }
    setIsLoading(false);
  };

  const handleGoBack = () => {
    history.goBack();
  };

  const handleDeleteFile = async (fileId) => {
    try {
      await dispatch(deleteFile(fileId));
      history.push({
        pathname: FILES_URL,
      });
      enqueueSnackbar("File has been deleted", {
        variant: "success",
      });
      posthog.capture(DELETE_FILE_SUCCESS);
    } catch (e) {
      posthog.capture(DELETE_FILE_FAILURE);
      console.log(e);
    }
  };

  const handleUpdateFile = async (file) => {
    try {
      await dispatch(updateFile(file));
      setFile(file);
      enqueueSnackbar("File name has been updated", {
        variant: "success",
      });
      posthog.capture(EDIT_FILE_SUCCESS);
    } catch (e) {
      console.log(e);
      posthog.capture(EDIT_FILE_FAILURE);
    }
  };

  return (
    <Page className={classes.root} title={"Files"}>
      {file && (
        <Content
          file={file}
          handleGoBack={handleGoBack}
          handleDeleteFile={handleDeleteFile}
          handleUpdateFile={handleUpdateFile}
        />
      )}
      {isLoading && <Loader />}
    </Page>
  );
}

export default ViewFile;
